import { Trans } from "@lingui/react/macro";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/_main_custom/about")({
    component: Component,
});

function Component() {
    return (
        <div className="p-2">
            <Trans>Hello world!</Trans>
        </div>
    );
}
